import React from 'react';
import c from 'classnames';

import MenuItemLinkElementDefault from '@uncinc/react-drupal-core/dist/Components/RecursiveMenu/index.default';
import type { MenuItemLinkElementProps } from '@uncinc/react-drupal-core/dist/Components/RecursiveMenu/types';

import { useMegaMenuContext } from '../../../../context/MegaMenuContext';

const DEFAULT_OVERLAY_DELAY = 300;

const MegaMenuTopMenuItemLinkElement: React.FC<MenuItemLinkElementProps> = (props) => {
  const {
    item,
    ...restProps
  } = props;

  const {
    overlayDelay = DEFAULT_OVERLAY_DELAY,
    openOverlayDelay,
    expandedMenuItem,
    updateExpandedMenuItem,
  } = useMegaMenuContext();

  const classes = c('MegaMenu__TopMenu__ItemLinkElement', `MegaMenu__TopMenu__ItemLinkElement--layer__${item.depth}`);

  if (item.has_children) {
    return (
      <div
        className={classes}
        onMouseEnter={() => {
          if (openOverlayDelay.current) {
            clearTimeout(openOverlayDelay.current);
          }

          openOverlayDelay.current = setTimeout(() => {
            updateExpandedMenuItem(item.link.id);
          }, overlayDelay);
        }}
        onMouseLeave={() => {
          if (openOverlayDelay.current) {
            clearTimeout(openOverlayDelay.current);
          }
        }}
      >
        <MenuItemLinkElementDefault
          {...restProps}
          item={item}
          linkProps={{
            'aria-expanded': expandedMenuItem === item.link.id,
          }}
        />
      </div>
    );
  }

  return (
    <MenuItemLinkElementDefault {...props} />
  );
};

export default MegaMenuTopMenuItemLinkElement;
